__turbopack_context__.v({
  "closeBtn": "bSAvfW_closeBtn",
  "drawerContent": "bSAvfW_drawerContent",
  "number": "bSAvfW_number",
});
